import { Component, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, Renderer2, Input, NgModule } from '@angular/core';
import { Fade } from 'ifast-ui-ng-tools/animations';
import { CommonModule } from '@angular/common';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { I18nModule, StandardDatePipe } from 'b2c-ui/i18n';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-user-profile.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CUserProfileModule } from 'b2c-ui/user-profile';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'ng-zorro-antd/card';
import * as ɵngcc3 from 'ng-zorro-antd/avatar';

function B2CUserProfileComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CUserProfileComponent_ng_template_1_div_2_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" Since ", ctx_r7._date, " \u2022 ", ctx_r7.count, " Articles");
} }
function B2CUserProfileComponent_ng_template_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h3", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "p", 7);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, B2CUserProfileComponent_ng_template_1_div_2_p_5_Template, 2, 2, "p", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5._date && ctx_r5.count);
} }
function B2CUserProfileComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("@fadeInDown", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.description);
} }
function B2CUserProfileComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nz-card", 3);
    ɵngcc0.ɵɵlistener("mouseenter", function B2CUserProfileComponent_ng_template_1_Template_nz_card_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.mouseOver(); })("mouseleave", function B2CUserProfileComponent_ng_template_1_Template_nz_card_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.mouseOut(); });
    ɵngcc0.ɵɵelement(1, "nz-avatar", 4);
    ɵngcc0.ɵɵtemplate(2, B2CUserProfileComponent_ng_template_1_div_2_Template, 6, 3, "div", 5);
    ɵngcc0.ɵɵtemplate(3, B2CUserProfileComponent_ng_template_1_ng_container_3_Template, 3, 2, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@fadeInDown", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzSize", ctx_r2.showDesc ? 70 : 200)("nzSrc", ctx_r2.image);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.showDesc);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showDesc);
} }
const _c0 = function (a0, a1, a2) { return { "lg": a0, "md": a1, "sm": a2 }; };
function B2CUserProfileComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelement(2, "nz-avatar", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelementStart(4, "div", 13);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "span", 14);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(7, _c0, ctx_r4.size === "lg", ctx_r4.size === "md", ctx_r4.size === "sm"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("nzSize", ctx_r4.size === "lg" ? 50 : ctx_r4.size === "md" ? 45 : ctx_r4.size === "sm" ? 35 : 45)("nzSrc", ctx_r4.image);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.size);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.size);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.title);
} }
class B2CUserProfileComponent {
    /**
     * @ignore
     * @param {?} elementRef
     * @param {?} renderer
     */
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.showDesc = false;
        /**
         * Set profile to list view
         */
        this.horizontal = false;
        /**
         * Set horizontal user profile size
         */
        this.size = 'md';
        this.renderer.addClass(elementRef.nativeElement, 'b2c-user-profile');
    }
    /**
     * Set The Date of Article
     * @param {?} value
     * @return {?}
     */
    set date(value) {
        /** @type {?} */
        const nativeDate = this.checkDateType(value)
            .toString()
            .split(' ');
        this._date = nativeDate[1].toString() + ' ' + nativeDate[3];
    }
    /**
     * @return {?}
     */
    mouseOver() {
        this.showDesc = true;
    }
    /**
     * @return {?}
     */
    mouseOut() {
        this.showDesc = false;
    }
    /**
     * @ignore
     * @private
     * @param {?} value
     * @return {?}
     */
    checkDateType(value) {
        if (typeof value === 'string' || typeof value === 'number') {
            return new Date(value);
        }
        else {
            return value;
        }
    }
    /**
     * @ignore
     * @return {?}
     */
    ngOnInit() { }
}
B2CUserProfileComponent.ɵfac = function B2CUserProfileComponent_Factory(t) { return new (t || B2CUserProfileComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
B2CUserProfileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CUserProfileComponent, selectors: [["b2c-user-profile"]], inputs: { horizontal: "horizontal", size: "size", date: "date", name: "name", title: "title", image: "image", description: "description", count: "count" }, exportAs: ["b2cUserProfile"], decls: 5, vars: 1, consts: [[4, "ngTemplateOutlet"], ["profileDefault", ""], ["profileHorizontal", ""], [1, "user-profile", "text-center", "hover", 3, "mouseenter", "mouseleave"], ["nzIcon", "user", 3, "nzSize", "nzSrc"], [4, "ngIf"], [1, "mb-1", "mt-2"], [1, "font-weight-bold", "m-0", "title"], ["class", "b2c-aurhor-last-update m-0 pt-3", 4, "ngIf"], [1, "b2c-aurhor-last-update", "m-0", "pt-3"], [1, "text-black-6", "text-sm", "pt-3"], [1, "b2c-user-profile-horizontal", 3, "ngClass"], [1, "pr-2"], [1, "b2c-user-profile-name", 3, "ngClass"], [1, "b2c-user-profile-title", 3, "ngClass"]], template: function B2CUserProfileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, B2CUserProfileComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, B2CUserProfileComponent_ng_template_1_Template, 4, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, B2CUserProfileComponent_ng_template_3_Template, 8, 11, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.horizontal ? _r3 : _r1);
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc2.NzCardComponent, ɵngcc3.NzAvatarComponent, ɵngcc1.NgIf, ɵngcc1.NgClass], encapsulation: 2, data: { animation: [
            Fade.fadeIn({
                direction: 'Down'
            })
        ] }, changeDetection: 0 });
/** @nocollapse */
B2CUserProfileComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
B2CUserProfileComponent.propDecorators = {
    horizontal: [{ type: Input }],
    name: [{ type: Input }],
    title: [{ type: Input }],
    image: [{ type: Input }],
    description: [{ type: Input }],
    size: [{ type: Input }],
    date: [{ type: Input }],
    count: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CUserProfileComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-user-profile',
                exportAs: 'b2cUserProfile',
                template: "<ng-container *ngTemplateOutlet=\"horizontal? profileHorizontal: profileDefault\"></ng-container>\r\n\r\n<ng-template #profileDefault>\r\n  <nz-card @fadeInDown class=\"user-profile text-center hover\" (mouseenter)=\"mouseOver()\" (mouseleave)=\"mouseOut()\">\r\n    <nz-avatar [nzSize]=\"showDesc ? 70: 200\" [nzSrc]=\"image\" nzIcon=\"user\"></nz-avatar>\r\n    <div *ngIf=\"!showDesc\">\r\n      <h3 class=\"mb-1 mt-2\">{{ name }}</h3>\r\n      <p class=\"font-weight-bold m-0 title\">{{ title }}</p>\r\n      <p class=\"b2c-aurhor-last-update m-0 pt-3\" *ngIf=\"_date && count\"> Since {{ _date }} \u2022 {{ count }} Articles</p>\r\n    </div>\r\n    <ng-container *ngIf=\"showDesc\">\r\n      <p @fadeInDown class=\"text-black-6 text-sm pt-3\">{{ description }}</p>\r\n    </ng-container>\r\n  </nz-card>\r\n</ng-template>\r\n\r\n<ng-template #profileHorizontal>\r\n  <div class=\"b2c-user-profile-horizontal\" [ngClass]=\"{\r\n    'lg':size === 'lg',\r\n    'md':size === 'md',\r\n    'sm':size === 'sm'\r\n  }\">\r\n    <div class=\"pr-2\">\r\n      <nz-avatar [nzSize]=\"size === 'lg' ? 50 : size === 'md'? 45 : size === 'sm'? 35 : 45\" [nzSrc]=\"image\" nzIcon=\"user\"></nz-avatar>\r\n    </div>\r\n    <div>\r\n      <div class=\"b2c-user-profile-name\" [ngClass]=\"size\">{{ name }}</div>\r\n      <span class=\"b2c-user-profile-title\" [ngClass]=\"size\">{{ title }}</span>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                animations: [
                    Fade.fadeIn({
                        direction: 'Down'
                    })
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { horizontal: [{
            type: Input
        }], size: [{
            type: Input
        }], date: [{
            type: Input
        }], name: [{
            type: Input
        }], title: [{
            type: Input
        }], image: [{
            type: Input
        }], description: [{
            type: Input
        }], count: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CUserProfileComponent.prototype.showDesc;
    /** @type {?} */
    B2CUserProfileComponent.prototype._date;
    /**
     * Set profile to list view
     * @type {?}
     */
    B2CUserProfileComponent.prototype.horizontal;
    /**
     * Set profile name
     * @type {?}
     */
    B2CUserProfileComponent.prototype.name;
    /**
     * Set profile title
     * @type {?}
     */
    B2CUserProfileComponent.prototype.title;
    /**
     * Set profile image
     * @type {?}
     */
    B2CUserProfileComponent.prototype.image;
    /**
     * Set profile description
     * @type {?}
     */
    B2CUserProfileComponent.prototype.description;
    /**
     * Set horizontal user profile size
     * @type {?}
     */
    B2CUserProfileComponent.prototype.size;
    /**
     * Set Articles count
     * @type {?}
     */
    B2CUserProfileComponent.prototype.count;
    /** @type {?} */
    B2CUserProfileComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    B2CUserProfileComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-user-profile.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CUserProfileModule {
}
B2CUserProfileModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CUserProfileModule });
B2CUserProfileModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CUserProfileModule_Factory(t) { return new (t || B2CUserProfileModule)(); }, providers: [StandardDatePipe], imports: [[
            CommonModule,
            B2CNgzIconModule,
            NzToolTipModule,
            NzCardModule,
            NzAvatarModule,
            I18nModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CUserProfileModule, { declarations: function () { return [B2CUserProfileComponent]; }, imports: function () { return [CommonModule,
        B2CNgzIconModule,
        NzToolTipModule,
        NzCardModule,
        NzAvatarModule,
        I18nModule]; }, exports: function () { return [B2CUserProfileComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CUserProfileModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CUserProfileComponent],
                exports: [B2CUserProfileComponent],
                imports: [
                    CommonModule,
                    B2CNgzIconModule,
                    NzToolTipModule,
                    NzCardModule,
                    NzAvatarModule,
                    I18nModule
                ],
                providers: [StandardDatePipe]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-user-profile.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CUserProfileComponent, B2CUserProfileModule };


//# sourceMappingURL=b2c-ui-user-profile.js.map